export const acceptTypes = '.png, .jpg, .jpeg, .gif, .doc, .docx, .pdf, .xls, .xlsx';
export const imageTypes = ['image/jpeg', 'image/png', 'image/jpg'];
